export function getPrimaryResourceType(resource: any): string | null {
  return (
    resource?.resourceType ||
    resource?.displayResourceType ||
    resource?.extraDetails?.displayResourceType ||
    resource?.activityType ||
    null
  );
}

export function getDisplayResourceType(
  resource: any,
  dict: Record<string, string>,
  fallback: string = "None"
): string {
  const key = getPrimaryResourceType(resource);
  return key ? dict[key] || key : fallback;
}
